import request from '../../utils/request';
import commonFun from "@/utils/commonFun";
import {fileService} from "@/api/common/file-utils";

export const apiService = {
    search: (data) => {
        return request({
            url: '/ssr/query?version=2',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    getDetail: (id) => {
        return request({
            url: `/ssr/${id}?version=2`,
            method: 'get',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
        })
    },
    save: (ssr) => {
        return request({
            url: '/ssr/save?version=2',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: ssr
        })
    },
    updateSpecUploadStatus:(ssrId)=>{
        return request({
            url: '/ssr/updateSpecUploadStatus?version=2',
            method: 'post',
            data: ssrId
        })
    },
    issue: (data) => {
        return request({
            url: '/ssr/issue?version=2',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    suspend: (data) => {
        return request({
            url: '/ssr/suspend?version=2',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    saveMarkInfo: (data) => {
        return request({
            url: '/ssr/saveMarkInfo?version=2',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    supplierAccept: (data) => {
        return request({
            url: '/ssr/supplierAccept?version=2',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    quote: (data) => {
        return request({
            url: '/ssr/quote?version=2',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    getMarkId(roundId) {
        return request({
            url: `ssr/markInfo?version=2`,
            method: 'post',
            data: roundId
        })
    },
    shareScore(markSupplierId) {
        return request({
            url: `ssr/shareScore?version=2`,
            method: 'post',
            data: markSupplierId
        })
    },
    createBc(ttSsrId) {
        return request({
            url: `ssr/createBc?version=2`,
            method: 'post',
            data: ttSsrId
        })
    },
    finishRound(ssrId) {
        return request({
            url: `ssr/finishRound?version=2`,
            method: 'post',
            data: ssrId
        })
    },
    saveRoundMark(ssr) {
        return request({
            url: `ssr/saveRoundMark?version=2`,
            method: 'post',
            data: ssr
        })
    },
    exportCost(roundIds) {
        return request({
            url: `ssr/exportCost?version=2`,
            method: 'post',
            data: commonFun.convertToArray(roundIds),
            fullResponse: true,
            responseType: 'blob',
        }).then(resp => {
            fileService.respToFile(resp);
        })
    },
    exportCapacity(roundIds) {
        return request({
            url: `ssr/exportCapacity?version=2`,
            method: 'post',
            data: commonFun.convertToArray(roundIds),
            fullResponse: true,
            responseType: 'blob',
        }).then(resp => {
            fileService.respToFile(resp);
        })
    },
    exportLogistic(roundIds) {
        return request({
            url: `ssr/exportLogistic?version=2`,
            method: 'post',
            data: commonFun.convertToArray(roundIds),
            fullResponse: true,
            responseType: 'blob',
        }).then(resp => {
            fileService.respToFile(resp);
        })
    },
    saveLogisticInfo(pacpArr) {
        return request({
            url: `ssr/saveLogisticInfo?version=2`,
            method: 'post',
            data: pacpArr
        })
    },
    exportPqcp(roundIds,order) {
        return request({
            url: `ssr/exportPqcp?order=${order}&version=2`,
            method: 'post',
            data: commonFun.convertToArray(roundIds),
            fullResponse: true,
            responseType: 'blob',
        }).then(resp => {
            fileService.respToFile(resp);
        })
    },
    countRoundSupplierCostBreakdownFiles(roundId) {
        return request({
            url: `ssr/countRoundSupplierCostBreakdownFiles?roundId=${roundId}&version=2`,
            method: 'get',
        })
    },
    downloadAllSupplierCapacityFile(ssrId) {
        return request({
            url: `ssr/downloadAllSupplierCapacityFile?version=2`,
            method: 'post',
            data: ssrId,
            fullResponse: true,
            responseType: 'blob',
        }).then(resp => {
            fileService.respToFile(resp);
        })
    },
    downloadAllCostBreakdownFile(ssrId) {
        return request({
            url: `ssr/downloadAllCostBreakdownFile?version=2`,
            method: 'post',
            data: ssrId,
            fullResponse: true,
            responseType: 'blob',
        }).then(resp => {
            fileService.respToFile(resp);
        })
    },
    downloadRoundSupplierCapacityFile(roundId) {
        return request({
            url: `ssr/downloadRoundSupplierCapacityFile?version=2`,
            method: 'post',
            data: roundId,
            fullResponse: true,
            responseType: 'blob',
        }).then(resp => {
            fileService.respToFile(resp);
        })
    },
    downloadRoundSupplierCostBreakdownFile(roundId) {
        return request({
            url: `ssr/downloadRoundSupplierCostBreakdownFile?version=2`,
            method: 'post',
            data: roundId,
            fullResponse: true,
            responseType: 'blob',
        }).then(resp => {
            fileService.respToFile(resp);
        })
    },
    downloadTemplate(type) {
        return request({
            url: `ssr/downloadTemplate?version=2`,
            method: 'post',
            data: type,
            fullResponse: true,
            responseType: 'blob',
        }).then(resp => {
            fileService.respToFile(resp);
        })
    }
}
